import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard, NoAuthGuard } from "@core";

const routes: Routes = [
  {
    path: "",
    redirectTo: "auth",
    pathMatch: "full",
  },
  {
    path: "auth",
    canActivate: [NoAuthGuard],

    loadChildren: () => import("./views/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "main",
    canActivate: [AuthGuard],
    loadChildren: () => import("./views/main/main.module").then((m) => m.MainModule),
  },
  {
    path: "settings",
    canActivate: [AuthGuard],
    loadChildren: () => import("./views/settings/settings.module").then((m) => m.SettingsModule),
  },
  {
    path: "stats",
    canActivate: [AuthGuard],
    loadChildren: () => import("./views/stats/stats.module").then((m) => m.StatsModule),
  },
  {
    path: "scores",
    canActivate: [AuthGuard],
    loadChildren: () => import("./views/scores/scores.module").then((m) => m.ScoresModule),
  },
  {
    path: "challenge/:category_id/:level_id/:variant_id",
    canActivate: [AuthGuard],
    loadChildren: () => import("./views/challenge/challenge.module").then((m) => m.ChallengeModule),
  },
  {
    path: "styleguide",
    loadChildren: () =>
      import("./views/styleguide/styleguide.module").then((m) => m.StyleguideModule),
  },
  {
    path: "colors",
    loadChildren: () =>
      import("./views/styleguide-colors/styleguide-colors.module").then(
        (m) => m.StyleguideColorsModule,
      ),
  },
  { path: "**", redirectTo: "/main" },
];

// prettier-ignore
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
